/**
 * @flow
 * @relayHash 9ca45724e0596d5035c7805a0e568966
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteJobLinkedItemInput = {|
  itemId: string,
  jobId: string,
|};
export type DeleteJobLinkedItemMutationVariables = {|
  input: DeleteJobLinkedItemInput
|};
export type DeleteJobLinkedItemMutationResponse = {|
  +deleteJobLinkedItem: {|
    +deletedItemId: string
  |}
|};
export type DeleteJobLinkedItemMutation = {|
  variables: DeleteJobLinkedItemMutationVariables,
  response: DeleteJobLinkedItemMutationResponse,
|};
*/


/*
mutation DeleteJobLinkedItemMutation(
  $input: DeleteJobLinkedItemInput!
) {
  deleteJobLinkedItem(input: $input) {
    deletedItemId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteJobLinkedItemInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteJobLinkedItem",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteJobLinkedItemPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedItemId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteJobLinkedItemMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteJobLinkedItemMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteJobLinkedItemMutation",
    "id": null,
    "text": "mutation DeleteJobLinkedItemMutation(\n  $input: DeleteJobLinkedItemInput!\n) {\n  deleteJobLinkedItem(input: $input) {\n    deletedItemId\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '44e00260c794496e937b49429afebe33';
module.exports = node;
